// export const BASE_URL = "https://handsfreeapi.com";
export const BASE_URL = "https://stage.handsfreeapi.com";
export const EP_URL = "https://easypointapi.com/api";
export const EP_PROD_URL = "https://prod.easypointapi.com/api";

export const EP_PROD_KEY = "wHjOKqH25WwOEeHphyGR";
export const EP_PROD_SECRET = "37m2LWciLhboNNFA6UkQ";

export const EP_KEY = "1k8FbYJ1j5q7DkzcQ5Vj";
export const EP_SECRET = "hZvYnUiPZHnc14tJLLAL";

export const KEY = "likEFOTAmapmDwWdBcFf";
export const SECRET = "IUT6nGY30ucth6HKXXSb";

// default key secret
export const DEFAULT_KEY = "CeQJ3t6OT8Ka5RTiDPU1tBepbUQumY";
export const DEFAULT_SECRET = "4VtrWHHHrWYmnYUlOHncj7DSlapfhA";

// exchange api
// export const TCMB_BASE_URL = "https://api.exchangerate-api.com/v4/latest/EUR";
export const TCMB_BASE_URL = "https://hasanadiguzel.com.tr/api/kurgetir";
